import React from 'react';
import './TopLinks.css';
import X from '../assets/xBlue.png';
import telegram from '../assets/telegramBlue.png';
import dexscreener from '../assets/dexscreenerBlue.png';

export default function TopLinks() {
  return (
    <div className="TopLinks">
      <a href="https://x.com/ALF_Starknet" className="TopLinkContainerImage" target="_blank" rel="noopener noreferrer">
        <img className="TopLinkImage" src={X} alt="X" />
      </a>
      <a href="https://t.me/Alf_Starknet" className="TopLinkContainerImage" target="_blank" rel="noopener noreferrer">
        <img className="TopLinkImage" src={telegram} alt="telegram" />
      </a>
      <a href="https://dexscreener.com/starknet/0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d-0x078d7dfcddb44667153513bd837ff534ef395484f4b6cf28faa25b2c46e063d9-3402823669209384634633746074317682114-5982-0x0" className="TopLinkContainerImage" target="_blank" rel="noopener noreferrer">
        <img className="TopLinkImage" src={dexscreener} alt="dexscreener" />
      </a>
    </div>
  );
}